import DOMPurify from 'dompurify';

const sanitizeHtml = (value) => {
  if (!value) return '';
  return DOMPurify.sanitize(value, {
    USE_PROFILES: { html: true },
    ADD_TAGS: ['img', 'figure', 'figcaption'],
    ADD_ATTR: ['style', 'class', 'id', 'data-align', 'width', 'height'],
    ALLOW_DATA_ATTR: true,
  });
};

export default sanitizeHtml;
